export const CSS_SPECIFICITY = {
  BASIC: '&',
  OVERRIDE: '&&',
  FORCE_OVERRIDE: '&&&'
};